<template>
  <div class="bg-white h-100">
    <LmComponentLoading v-if="isLoading" />
    <div class="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
      <i class="mdi" :class="icon" style="font-size: 1.5rem"></i>
      <h4 class="text-center m-0">{{ title }}</h4>
      <span class="clickable" @click="$emit('close')">
        <i class="mdi mdi-close" style="font-size: 1.5rem"></i>
      </span>
    </div>
    <div class="scroll">
      <a-timeline
        class="p-4"
        mode="alternate"
        v-if="movements.items.length"
      >
        <a-timeline-item
          v-for="(m, index) of movements.items"
          :key="index"
          :color="m.color || 'gray'"
        >
          <a-icon
            v-if="m.icon"
            slot="dot"
            :type="m.icon"
            style="font-size: 22px;"
          />
          <div class="datos d-flex flex-column mx-2">
            <span class="font-weight-bold" :style="{color: titleColor[m.color]}">{{ m.movement_code }}</span>
            <span>
              <b-avatar
                v-if="!m.noavatar"
                class="my-2"
                size="2.6em"
                :text="emptyUserAvatar(m)"
                :src="m.avatar"
                v-b-popover.hover="popoverConfig(m, index)"
              ></b-avatar>
            </span>
            <!-- <span class="font-weight-bold">{{ m.created_by.firstname }} {{ m.created_by.lastname }}</span> -->
            <span
              v-if="m.area && m.subarea"
            >
              {{ m.area.name }} - {{ m.subarea.name }}
            </span>
            <span v-if="m.documentation">
              <b-link @click="onOpenDocumentationModal(m.documentation)">Abrir documento</b-link>
            </span>
            <span
              v-if="m.created_at"
              class="font-weight-light"
            >
              {{ m.created_at }}
            </span>
          </div>
        </a-timeline-item>
      </a-timeline>
    </div>
    <b-modal
      v-if="documentationPath"
      id="documentation-viewer-modal"
      size="xl"
      hide-footer
    >
      <iframe
        :src="documentationPath"
        frameborder="0"
        width="100%"
        class="preview-iframe"
      ></iframe>
    </b-modal>
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import moment from 'moment'
import LmButton from '@/components/form/elements/LmButton'

import 'moment/locale/es'
moment.locale('es')

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      titulo: 'Movimientos',
      isLoading: false,
      documentationPath: null,
      movements: {
        items: []
      },
      titleColor: {
        red: '#f5222d',
        gray: '#6c757d',
        green: '#52c41a',
        blue: '#1890ff'
      }
    }
  },
  components: {
    LmButton
  },
  methods: {
    emptyUserAvatar (m) {
      if (m.avatar) {
        return null
      }
      if (m.created_by) {
        return m.created_by?.firstname?.charAt(0) + m.created_by?.lastname?.charAt(0)
      }
      return null
    },
    userFullName (m) {
      return `${m.created_by?.firstname} ${m.created_by?.lastname}`
    },
    popoverConfig (m, index) {
      return {
        content: () => this.userFullName(m),
        placement: index % 2 === 0 ? 'right' : 'left'
      }
    },
    onOpenDocumentationModal (documentation) {
      this.documentationPath = process.env.VUE_APP_API_URL_STATIC_ASSETS + documentation.documentPath
      this.$nextTick(() => this.$bvModal.show('documentation-viewer-modal'))
    }
  },
  async created () {
    try {
      this.isLoading = true
      const response = await commonsApi.axiosGetWrapper(`/documents/movements/${this.$route.params.id}`)

      let movements = response.data?.rows || []
      if (movements.some(el => el.movement)) {
        const mapped = []
        for (const mov of movements) {
          let userData = mov.created_by || {}
          if (mov?.created_by?.id) {
            const { data } = await commonsApi.axiosGetWrapper(`/users/user-meta/${mov.created_by.id}`)
            if (data) {
              userData = data
            }
          }
          mapped.push({
            created_at: moment(mov.created_at).format('DD [de] MMMM - hh:mm:ss'),
            movement_code: mov.movement.code,
            color: mov.movement.color,
            icon: mov.movement.icon,
            created_by: userData || null,
            area: mov.movement.impersonal ? '' : mov.created_by?.area,
            subarea: mov.movement.impersonal ? '' : mov.created_by?.subarea,
            avatar: userData.profilePicture || null,
            noavatar: mov.movement.impersonal,
            documentation: mov.documentation
          })
        }
        movements = mapped
      }

      this.movements.items = movements
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style lang="sass" scoped>
  .scroll
    height: calc(100% - 70px)
    overflow-y: auto
    &:hover
      &::-webkit-scrollbar-thumb
        border-radius: 20px
        background: #888
    &::-webkit-scrollbar
      width: 8px
    &::-webkit-scrollbar-thumb
      border-radius: 20px
      background: transparent
    &::-webkit-scrollbar-thumb:hover
      background: #555
</style>
